exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#flow-container {\r\n    overflow:hidden !important;\r\n    margin-top: 20px;\r\n}\r\n\r\n#iframe{\r\n    display:block; \r\n    width:100%; \r\n    height:0px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/flow-preview/flow-preview.component.css
// module id = ../../../../../src/app/private/product/flow-preview/flow-preview.component.css
// module chunks = main